import React, { Component } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import {BrowserRouter, Route} from 'react-router-dom';
import { theme } from './config/theme';
import Header from './common/Header';
import Footer from './common/Footer';
import ScrollTop from './common/ScrollTop';
import Index from './pages/index';
import User from './pages/user';
import Stats from './pages/stats';

class App extends Component {
  render() {
    document.title = "ShittyReply Killer(クソリプバスター)";
    return (
      <div className="App">
        <MuiThemeProvider theme={theme}>
          <BrowserRouter>
            <div>
              <CssBaseline />
              <Header/>
              <div>
                <ScrollTop>
                  <Route exact={true} path='/' component={Index}/>
                  <Route exact={true} path='/success' component={User}/>
                  <Route exact={true} path='/stats' component={Stats}/>
                </ScrollTop>
              </div>
              <Footer/>
            </div>
          </BrowserRouter>
        </MuiThemeProvider>
      </div>
    );
  }
}

export default App;
